import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Drawer,message,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select,Modal,   } from 'antd';
import { EditOutlined } from '@ant-design/icons' ;

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import add from '../../assets/images/icon/add.png';
import edit from '../../assets/images/icon/edit.png';
import boy from '../../assets/images/icon/boy.png';
import girl from '../../assets/images/icon/girl.png';

const { TextArea } = Input;
const { Panel } = Collapse;
const { Option } = Select;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			class: '',
			academic_year: '',
			subject: '',
			teacher: [],
			timetable_id: '',
			class_list: [],
			timetable_list: [],
			staff_list: [],
			tab: 'Monday',
			loading: false,
			mobile_child: false,
			academic_year_: [],
			division_list: [],
			subject_list: [],
			teacher_list: [],
			academic_year: '',
			division: '',
		}
		this.change_class = this.change_class.bind(this);
		this.change_year = this.change_year.bind(this);
		this.change_teacher = this.change_teacher.bind(this);
		this.change_subject = this.change_subject.bind(this);
		this.updatetable = this.updatetable.bind(this);
		this.change_division = this.change_division.bind(this);
	}
	
	showDrawer = (id) => {
		this.setState({
		  mobile_child: true,
		  timetable_id: id,
		});
	  };
	 
	onClose = () => {
		this.setState({
		  mobile_child: false,
		});
	  }; 

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
		
		}
		this.checkData()
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			var type = storedArray['data'][0]['type'];
			var app = {school_id : school_id,user_id:user_id,type:type}
			getData('erp/new_program_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							class_list: result['data'],
						});
					}else{
						this.setState({
							class_list: [],
							
						});
					}
				}
			});
			getData('common/get_academic_year',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							academic_year_: result['data'],
						});
					}else{
						this.setState({
							academic_year_: [],
						});
					}
				}
			});
			getData('Timetable/subject_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							subject_list: result['data'],
						});
					}else{
						this.setState({
							subject_list: [],
						});
					}
				}
			});
			getData('erp/get_teacher_list',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							teacher_list: result['data'],
						});
					}else{
						this.setState({
							teacher_list: [],
						});
					}
				}
			});
		}			
	}
	
	checkData2(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			var day = this.state.tab;
			var eclass = this.state.class;
			var academic_year = this.state.academic_year;
			var division = this.state.division;
			var app = {school_id : school_id,user_id:user_id,day:day,class:eclass,academic_year:academic_year,division:division}
			getData('Timetable/manage_timetable',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							timetable_list: result['data'],
						});
					}else{
						this.setState({
							timetable_list: [],
							
						});
					}
				}
			});
		}		
	}
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	  };
	  
	change_division(event){
        this.setState({division: event});
		setTimeout(() => {
			this.checkData2();
		}, 20);	
    }  
	  
	handletabchange=(e)=>{
			this.setState({
					tab: e,
				});
			setTimeout(() => {
				this.checkData2();
			}, 20);		
			
	} 
	
	showModal = (id) => {
		
		var app = {timetable_id : id}
		getData('Timetable/get_timetable_details',app).then((result) => {
			let responseJson = result;
			if(result['status'] == 200){
				setTimeout(() => {
					this.setState({
						teacher: result['teacher'],
						subject: result['subject'],
					});
				}, 20);	
				
			}else{
				setTimeout(() => {
					this.setState({
						teacher: [],
						subject: '',
					});
				}, 20);	
			}
		});
		this.setState({
		  visible: true,
		  timetable_id: id,
		});
	  };

	handleOk = e => {
		console.log(e);
		this.setState({
		  visible: false,
		});
	  };

	handleCancel = e => {
		console.log(e);
		this.setState({
		  visible: false,
		});
	};
	  
	change_class(event){
        this.setState({class: event,division_list:[],division:''});
		var app = {user_id : this.state.user_id,program_id:event,school_id:this.state.school_id}
		getData('erp/division_list_by_class',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					this.setState({
						division_list: result['data'],
					});
				}else{
					this.setState({
						division_list: [],
					});
				}
			}
		});
		setTimeout(() => {
			this.checkData2();
		}, 20);		
    }
		
	change_year(event){
         this.setState({academic_year: event});
		 setTimeout(() => {
				this.checkData2();
			}, 20);	
     }	
	 
	change_subject(event){
         this.setState({subject: event});
     }
	 
	change_teacher(event){
         this.setState({teacher: event});
     }
	 
	updatetable=(e)=>{
	    if(this.state.subject == ''){
			this.setState({loading: false,mobile_child: false}); 
			message.config({ top: 150});
			message.error('Please Select Subject',2);
		}else if(this.state.teacher.length == 0){
			this.setState({loading: false,mobile_child: false}); 
			message.config({ top: 150});
			message.error('Please Select Teacher',2);
		}else{
			var app = {
			timetable_id : this.state.timetable_id,
			teacher : this.state.teacher,
			subject : this.state.subject,
		  }
			this.setState({loading: true});  
			getData('Timetable/update_teacher_subject',app).then((result) => {
				let responseJson = result;
				if(result['status'] == 200){
					message.config({ top: 150});
					message.success('Timetable Updated',2);
					this.setState({
						timetable_id: '',
						teacher: [],
						subject: '',
						visible: false,
						loading: false,
						mobile_child: false,
						
					});
					setTimeout(() => {
						this.checkData2();
					}, 20);	
					
				}else{
					this.setState({loading: false,mobile_child: false}); 
					message.config({ top: 150});
					message.error('Something went wrong',2);
				}
			});
		}
		
	} 
	 
	render()

	{
	
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div class="row bred">
				<div class="col-md-12">
				<div class="card">
				<div class="card-body">
					<h4 class="page-title"> 
						<i class="mdi mdi-apple-keyboard-command title_icon"></i>Manage Time Table
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item">
									<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
									<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
									</a>
								</li>
								<li class="breadcrumb-item"> Manage Time Table </li>
							</ol>
						</div>
					</h4>
				</div>
				</div>
				</div>
			</div>
			
			<div class="row">
				<div class="col-md-12">
				<div class="card-body no-padd-i">
					<ul class="nav nav-tabs nav-tabs-solid">
						<li class="nav-item"><a href={`${process.env.PUBLIC_URL}/time-table/list`} class="nav-link ">Time Table List</a></li>
						<li class="nav-item"><a href={`${process.env.PUBLIC_URL}/time-table/manage`} class="nav-link active">Time Table Manage</a></li>
					</ul>
				</div>
				</div>
			</div>
			
			<div id="main" class="bg-off">
         <div class="row">
			
		 
		 	
           
		   <div class="col col-md-12 ex-padd view-Profile view-Profile-mobile"> 
            <div class="card">
				<div class="card-body">
			   <div class="col col-md-12 mb-20  mh-500 no-padd">
                  <section class="section food no-padd">
					<div class="children mb-20 mh-40 time-table form-group">
						
					<div class="desktop-view home-dash">
						<div class="row">
								<div class="col-md-3 mb-20">
									<label>Select Academic Year</label>
									<Select onChange={this.change_year} value={this.state.academic_year}>
										<Select.Option value="">Select Academic Year</Select.Option>
										{this.state.academic_year_.map((list) => (
											<Select.Option value={list.name}>{list.name}</Select.Option>
										))}
							        </Select> 
								</div>
								<div class="col-md-3 mb-20">
									<label>Select Class</label>
									<Select onChange={this.change_class} value={this.state.class} >
										<Select.Option value="">Select Class</Select.Option>
										{this.state.class_list.map((list)=> (
											<Select.Option value={list.id}>{list.name}</Select.Option>
										))}
									</Select>
								</div>	
								<div class="col-md-3 mb-20">
									<label>Select Division</label>
									<Select onChange={this.change_division} value={this.state.division}>
											<Select.Option value="">Select Division</Select.Option>
											{this.state.division_list.map((list) => (
												<Select.Option value={list.id}>{list.name}</Select.Option>
											))}
									</Select>
								</div>									
							
						</div>	
							
						<div class="col-md-12 no-padd">
						<div class="card-body no-padd-i">
							<ul class="nav nav-tabs nav-tabs-solid">
								<li class="nav-item">
									<a href="javascript:void(0);" class={`nav-link ${this.state.tab == 'Monday'?'active':'a'}`} onClick={this.handletabchange.bind(this,'Monday')}>Monday</a>
								</li>
								<li class="nav-item">
									<a href="javascript:void(0);" class={`nav-link ${this.state.tab == 'Tuesday'?'active':'a'}`} onClick={this.handletabchange.bind(this,'Tuesday')}>Tuesday</a>
								</li>
								<li class="nav-item">
									<a href="javascript:void(0);" class={`nav-link ${this.state.tab == 'Wednesday'?'active':'a'}`} onClick={this.handletabchange.bind(this,'Wednesday')}>Wednesday</a>
								</li>
								<li class="nav-item">
									<a href="javascript:void(0);" class={`nav-link ${this.state.tab == 'Thursday'?'active':'a'}`} onClick={this.handletabchange.bind(this,'Thursday')}>Thursday</a>
								</li>
								<li class="nav-item">
									<a href="javascript:void(0);" class={`nav-link ${this.state.tab == 'Friday'?'active':'a'}`} onClick={this.handletabchange.bind(this,'Friday')}>Friday</a>
								</li>
								<li class="nav-item">
									<a href="javascript:void(0);" class={`nav-link ${this.state.tab == 'Saturday'?'active':'a'}`} onClick={this.handletabchange.bind(this,'Saturday')}>Saturday</a>
								</li>
								
							</ul>
						</div>
						</div>	
						
						
						<div class="table-responsive mt-10">
							<table class="table table-striped table-bordered table-hover">
								<thead>
									<tr>
										<th>Lecture Name</th>
										<th>Lecture Time</th>
										<th>Subject</th>
										<th>Teacher</th>
										<th>Edit</th>
									</tr>
								</thead>
								<tbody>
									{this.state.timetable_list.map((list) => (
									<tr class={`${list.type == 'period' ? '' : 'gray'}`}>
										<td data-label="Lecture Name">{list.period_name}</td>
										<td data-label="Lecture Time">{list.timing}</td>
										<td data-label="Subject">{list.subject}</td>
										<td data-label="Teacher">
										{list.teacher.map((teach) => (
										<><li>{teach}</li></>
										))
										}
										
										</td>
										{list.type == 'period' ? (<><td  data-label="Edit" onClick={this.showModal.bind(this,list.id)}><span class="pointer"><EditOutlined /></span></td></>):(<><td data-label="Edit"></td></>)}
									</tr>
									))}
									
									{(() => {  
									if (this.state.timetable_list.length =='0') {
											return (
														<td id="error" class="center" colspan="5">No Data Found</td>
													)
											}
									})()}
									
								</tbody>
							</table>
						</div>		
					</div>
						
						
					</div> 
					
					<Modal
					  title="Update Subject"
					  visible={this.state.visible}
					  onOk={this.handleOk}
					  onCancel={this.handleCancel}
					  className="view-Profile"
					>
							<div class="col-md-12 mt-20">
							<div class="row">
							<div class="col-md-12 mb-20 dis-input form-group">
									<label>Select Subject </label>
									<Select onChange={this.change_subject} value={this.state.subject}>
											<Select.Option value="">Select Subject</Select.Option>
											{this.state.subject_list.map((list) => (
												<Select.Option value={list.id}>{list.name}</Select.Option>
											))}
									</Select>
							</div>
							<div class="col-md-12 mb-20 dis-input form-group">
									<label>Select Teacher </label>
									<Select mode="multiple" onChange={this.change_teacher} placeholder="Select Teacher" value={this.state.teacher}>
											{this.state.teacher_list.map((list) => (
												<Select.Option value={list.id}>{list.name}</Select.Option>
											))}
									</Select>
							</div>
							<div class="col col-md-12 s12 meal bt mt-10 pt-10 text-center">
								 <Button className="btn btn-primary mr-2 mb-0" id="submit_btn" onClick={this.updatetable} loading={this.state.loading} >Update</Button>
							</div>
							</div>
							</div>
					  
					</Modal>
					
					
					
					
                  </section>
               </div>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
